import { forwardRef } from 'react';
import { CoreIcon } from '@autopass-web/mochi-icons';
import styles from './mochi-input.module.sass';
import classnames from 'classnames/bind';
import iconClose from '../../../../domain/assets/close.svg';

const cx = classnames.bind(styles);

export interface MochiInputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  errorMessage?: string | null | undefined;
  variant?: 'normal' | 'round' | 'grey';
  disabled?: boolean;
  onClear?: () => void;
  beforeValue?: string;
  isDarkMode?: boolean;
  containerClassName?: string;
  iconRight?: React.ReactNode;
}

export const MochiInput = forwardRef<HTMLInputElement, MochiInputProps>(
  (props, ref) => {
    const {
      errorMessage,
      variant = 'normal',
      disabled = false,
      beforeValue,
      onClear,
      isDarkMode = false,
      iconRight,
      containerClassName = '',
      ...inputProps
    } = props;

    const containerClass = cx({
      container: true,
      error: errorMessage != null && errorMessage !== '',
      disabled: disabled || inputProps.readOnly,
      [variant]: true,
      'light-mode': !isDarkMode,
      'dark-mode': isDarkMode,
    });

    const inputClass = cx(
      {
        input: true,
        'light-mode': !isDarkMode,
        'dark-mode': isDarkMode,
      },
      inputProps.className,
    );

    const errorMessageClass = cx({
      'error-message': true,
    });

    return (
      <div className={`${styles['mochi-input']} ${inputProps.className}`}>
        <div className={`${containerClass} ${containerClassName}`}>
          {beforeValue && (
            <div className={styles['before-value']}>{beforeValue}</div>
          )}
          <input {...inputProps} ref={ref} className={inputClass} />
          {iconRight}
          {onClear && inputProps.value && (
            <CoreIcon
              src={iconClose}
              className={styles.clear}
              onClick={onClear}
            />
          )}
        </div>
        {errorMessage && (
          <div className={errorMessageClass}>{errorMessage}</div>
        )}
      </div>
    );
  },
);
